<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab>
                <template slot="title">
                    <i class="icon-globe mr-2"></i>{{Core.Definition.getDefinition('Connexions API')}}
                </template>
                <b-row class="mb-2">
                    <b-col>
                        <b-button @click="onOpenModalAPIClick" class="btn btn-edit pull-right"><i class="fa fa-plus mr-2"></i>{{Core.Definition.getDefinition('Nouvelle connexion')}}</b-button>
                    </b-col>
                </b-row>
                <DynamicList
                        ref="dynamicCardList"
                        :searchFormStructure="dataSearchFormStructure"
                        :columns="dataColumns"
                        :edit="dataEdit"
                        root="/api/list"
                        :trash="dataTrash">
                </DynamicList>
                <ModalAPI
                        ref="modalAPI"
                        @onSave="onSave"></ModalAPI>
                <ModalTrash
                        ref="trash"
                        root="/api"
                        @onTrashSuccess="onTrashSuccess"
                        :caption="Core.Definition.getDefinition('Suppression de la connexion API')"
                        :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette connexion API?')"></ModalTrash>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DynamicForm from '../../../components/DynamicForm'
    import DynamicCardList from '../../../components/DynamicCardList'
    import DynamicList from '../../../components/DynamicList'
    import Request from '../../../components/Request'
    import InputText from '../../../components/InputText'
    import InputNumber from '../../../components/InputNumber'
    import ModalAPI from '../../../components/ModalAPI'
    import ModalTrash from '../../../components/ModalTrash'
    export default {
        name: 'SettingsAPI',
        components: {
            DynamicForm,
            Request,
            InputText,
            InputNumber,
            DynamicCardList,
            DynamicList,
            ModalAPI,
            ModalTrash
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataColumns: [
                    {
                        label: window.Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: window.Core.Definition.getDefinition('Nom'),
                        key: 'name',
                        sortable: true
                    },
                    {
                        label: window.Core.Definition.getDefinition('Domaine'),
                        key: 'domain',
                        sortable: true
                    },
                    {
                        label: window.Core.Definition.getDefinition('Token'),
                        key: 'token',
                        sortable: true
                    },
                    {
                        label: window.Core.Definition.getDefinition('Signature'),
                        key: 'signature',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'name'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'domain'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'name',
                            type: 'text',
                            label: window.Core.Definition.getDefinition('Nom'),
                            value: ''
                        },
                        {
                            id: 'domain',
                            type: 'text',
                            label: window.Core.Definition.getDefinition('Domaine'),
                            value: ''
                        }
                    ]
                },
                dataEdit: {
                    show: false
                },
                dataTrash: {
                    show: true,
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                }
            }
        },
        computed: {
        },
        methods: {
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            },
            onOpenModalAPIClick() {
                this.$refs.modalAPI.open = true
            },
            onSave(data) {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
